/* eslint-disable no-plusplus */
/* eslint-disable radix */


/**
 *
 * Recebe um cnpj no padrão 00000000000000 e retorna um Cnpj formatado 00.000.000/0000-00
 * @param {string} str
 * @return {string}  Ex.:00.000.000/0000-00
 */
function formatCNPJ(str) {
  if (!str) {
    return '';
  }
  return str.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
}

/**
 *
 * Recebe um cnpj no padrão 00.000.000/0000-00 e retorna um Cnpj formatado 00000000000000
 * @param {string} num
 * @return {string}  Ex.:00000000000000
 */
function numberCNPJ(str) {
  return str.replace(/[^\w]+/g, '');
}

const maskCnpj = [
  /\w/,
  /\w/,
  '.',
  /\w/,
  /\w/,
  /\w/,
  '.',
  /\w/,
  /\w/,
  /\w/,
  '/',
  /\w/,
  /\w/,
  /\w/,
  /\w/,
  '-',
  /\d/,
  /\d/,
];

export { formatCNPJ, numberCNPJ, maskCnpj };
